"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMaintenanceResolveDuplicateDisbursementMutation = exports.useMaintenanceResolveDuplicateVoucherMutation = exports.useMaintenanceSyncVoucherStatusMutation = exports.useMaintenanceReleaseVoucherMutation = exports.useMaintenanceDetachVoucherFromDisbursementMutation = exports.useLazyGetProductVouchersDrilldownQuery = exports.useGetProductVouchersDrilldownQuery = exports.useMarkVoucherUsedMutation = exports.useReleaseVoucherMutation = exports.useMarkVoucherFaultyMutation = exports.useGetStockHistoryQuery = exports.useUploadVouchersFileMutation = exports.useUploadVouchersMutation = exports.useGetBatchesQuery = exports.useGetVoucherQuery = exports.useLazyGetVouchersQuery = exports.useGetVouchersQuery = exports.useLazyGetStockSummaryQuery = exports.useGetStockSummaryQuery = exports.stockApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.stockApi = (0, react_1.createApi)({
    reducerPath: "stockApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["Stock", "Vouchers", "Batches"],
    endpoints: function (builder) { return ({
        getStockSummary: builder.query({
            query: function (params) { return ({
                url: "/v1/stock/summary",
                params: params,
            }); },
            providesTags: [{ type: "Stock", id: "SUMMARY" }],
            // Keep cache for only 30 seconds to ensure relatively fresh data
            keepUnusedDataFor: 30,
        }),
        getVouchers: builder.query({
            query: function (params) { return ({
                url: "/v1/stock/vouchers",
                params: params,
            }); },
            providesTags: [{ type: "Vouchers", id: "LIST" }],
        }),
        getVoucher: builder.query({
            query: function (id) { return "/v1/stock/vouchers/".concat(id); },
            providesTags: function (result, error, id) { return [{ type: "Vouchers", id: id }]; },
        }),
        getBatches: builder.query({
            query: function (params) { return ({
                url: "/v1/stock/batches",
                params: params,
            }); },
            providesTags: [{ type: "Batches", id: "LIST" }],
        }),
        uploadVouchers: builder.mutation({
            query: function (data) { return ({
                url: "/v1/stock/upload",
                method: "POST",
                body: data,
            }); },
            invalidatesTags: [
                { type: "Stock", id: "SUMMARY" },
                { type: "Vouchers", id: "LIST" },
                { type: "Batches", id: "LIST" },
            ],
        }),
        uploadVouchersFile: builder.mutation({
            query: function (formData) { return ({
                url: "/v1/stock/upload-file",
                method: "POST",
                body: formData,
            }); },
            invalidatesTags: [
                { type: "Stock", id: "SUMMARY" },
                { type: "Vouchers", id: "LIST" },
                { type: "Batches", id: "LIST" },
            ],
        }),
        getStockHistory: builder.query({
            query: function (params) { return ({
                url: "/v1/stock/history",
                params: params,
            }); },
        }),
        markVoucherFaulty: builder.mutation({
            query: function (_a) {
                var id = _a.id, reason = _a.reason;
                return ({
                    url: "/v1/stock/vouchers/".concat(id, "/mark-faulty"),
                    method: "POST",
                    body: { reason: reason },
                });
            },
            invalidatesTags: [
                { type: "Stock", id: "SUMMARY" },
                { type: "Vouchers", id: "LIST" },
            ],
        }),
        releaseVoucher: builder.mutation({
            query: function (id) { return ({
                url: "/v1/stock/vouchers/".concat(id, "/release"),
                method: "POST",
            }); },
            invalidatesTags: [
                { type: "Stock", id: "SUMMARY" },
                { type: "Vouchers", id: "LIST" },
            ],
        }),
        markVoucherUsed: builder.mutation({
            query: function (id) { return ({
                url: "/v1/stock/vouchers/".concat(id, "/mark-used"),
                method: "POST",
            }); },
            invalidatesTags: [
                { type: "Stock", id: "SUMMARY" },
                { type: "Vouchers", id: "LIST" },
            ],
        }),
        getProductVouchersDrilldown: builder.query({
            query: function (_a) {
                var productId = _a.productId, params = __rest(_a, ["productId"]);
                return ({
                    url: "/v1/stock/product/".concat(productId, "/vouchers"),
                    params: params,
                });
            },
            providesTags: function (result, error, _a) {
                var productId = _a.productId;
                return [{ type: "Vouchers", id: "PRODUCT_".concat(productId) }];
            },
        }),
        // ─── Maintenance / audit-screen repair actions ─────────────────────────
        maintenanceDetachVoucherFromDisbursement: builder.mutation({
            query: function (_a) {
                var disbursementId = _a.disbursementId, reason = _a.reason;
                return ({
                    url: "/v1/stock/maintenance/disbursements/".concat(disbursementId, "/detach-voucher"),
                    method: "POST",
                    body: { reason: reason },
                });
            },
            invalidatesTags: [
                { type: "Stock", id: "SUMMARY" },
                { type: "Vouchers", id: "LIST" },
            ],
        }),
        maintenanceReleaseVoucher: builder.mutation({
            query: function (_a) {
                var voucherId = _a.voucherId, reason = _a.reason;
                return ({
                    url: "/v1/stock/maintenance/vouchers/".concat(voucherId, "/release"),
                    method: "POST",
                    body: { reason: reason },
                });
            },
            invalidatesTags: [
                { type: "Stock", id: "SUMMARY" },
                { type: "Vouchers", id: "LIST" },
            ],
        }),
        maintenanceSyncVoucherStatus: builder.mutation({
            query: function (_a) {
                var voucherId = _a.voucherId, reason = _a.reason;
                return ({
                    url: "/v1/stock/maintenance/vouchers/".concat(voucherId, "/sync-status"),
                    method: "POST",
                    body: { reason: reason },
                });
            },
            invalidatesTags: [
                { type: "Stock", id: "SUMMARY" },
                { type: "Vouchers", id: "LIST" },
            ],
        }),
        maintenanceResolveDuplicateVoucher: builder.mutation({
            query: function (body) { return ({
                url: "/v1/stock/maintenance/resolve-duplicate-voucher",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: [
                { type: "Stock", id: "SUMMARY" },
                { type: "Vouchers", id: "LIST" },
            ],
        }),
        maintenanceResolveDuplicateDisbursement: builder.mutation({
            query: function (body) { return ({
                url: "/v1/stock/maintenance/resolve-duplicate-disbursement",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: [
                { type: "Stock", id: "SUMMARY" },
                { type: "Vouchers", id: "LIST" },
            ],
        }),
    }); },
});
exports.useGetStockSummaryQuery = exports.stockApi.useGetStockSummaryQuery, exports.useLazyGetStockSummaryQuery = exports.stockApi.useLazyGetStockSummaryQuery, exports.useGetVouchersQuery = exports.stockApi.useGetVouchersQuery, exports.useLazyGetVouchersQuery = exports.stockApi.useLazyGetVouchersQuery, exports.useGetVoucherQuery = exports.stockApi.useGetVoucherQuery, exports.useGetBatchesQuery = exports.stockApi.useGetBatchesQuery, exports.useUploadVouchersMutation = exports.stockApi.useUploadVouchersMutation, exports.useUploadVouchersFileMutation = exports.stockApi.useUploadVouchersFileMutation, exports.useGetStockHistoryQuery = exports.stockApi.useGetStockHistoryQuery, exports.useMarkVoucherFaultyMutation = exports.stockApi.useMarkVoucherFaultyMutation, exports.useReleaseVoucherMutation = exports.stockApi.useReleaseVoucherMutation, exports.useMarkVoucherUsedMutation = exports.stockApi.useMarkVoucherUsedMutation, exports.useGetProductVouchersDrilldownQuery = exports.stockApi.useGetProductVouchersDrilldownQuery, exports.useLazyGetProductVouchersDrilldownQuery = exports.stockApi.useLazyGetProductVouchersDrilldownQuery, exports.useMaintenanceDetachVoucherFromDisbursementMutation = exports.stockApi.useMaintenanceDetachVoucherFromDisbursementMutation, exports.useMaintenanceReleaseVoucherMutation = exports.stockApi.useMaintenanceReleaseVoucherMutation, exports.useMaintenanceSyncVoucherStatusMutation = exports.stockApi.useMaintenanceSyncVoucherStatusMutation, exports.useMaintenanceResolveDuplicateVoucherMutation = exports.stockApi.useMaintenanceResolveDuplicateVoucherMutation, exports.useMaintenanceResolveDuplicateDisbursementMutation = exports.stockApi.useMaintenanceResolveDuplicateDisbursementMutation;
